import * as Common from '_common';
import { RenderDashboardRoomButton, RenderDashboardRoomFull, RenderHotWaterPumpButtonRender, RenderProcessButton, } from './Dashboard';
import { GraphsRender } from './Graphs';
import { RenderRoomButtonWidget, RenderRoomFrameWidget, RenderRoomScreenWidget, } from './RoomWidgets';
import * as React from 'react';
import * as Mlt from '_mlt';
import { RenderGardenPumpButtonWidget, RenderGardenPumpFrameWidget, RenderGardenPumpScreenWidget, } from './GardenPumpWidgets';
const controlWidgetFactories = {
    room: ({ id, key }) => ({
        id,
        title: Mlt.getName(key),
        components: {
            [Common.WidgetSize.MinButton]: {
                type: 'widgetbutton',
                properties: { id },
            },
            [Common.WidgetSize.Button]: {
                type: 'house_roomButtonWidget',
                properties: { id },
            },
            [Common.WidgetSize.Frame]: {
                type: 'house_roomFrameWidget',
                properties: { id },
            },
            [Common.WidgetSize.FullScreen]: {
                type: 'house_roomScreenWidget',
                properties: { id },
            },
        },
        defaultPlacement: {
            type: Common.WidgetPlaceholderType.Tiles,
            size: Common.WidgetSize.Button,
            section: 'rooms',
        },
    }),
    gardenpump: ({ id, key }) => ({
        id,
        title: Mlt.getName(key),
        components: {
            [Common.WidgetSize.MinButton]: {
                type: 'widgetbutton',
                properties: { id },
            },
            [Common.WidgetSize.Button]: {
                type: 'house_gardenPumpButtonWidget',
                properties: { id },
            },
            [Common.WidgetSize.Frame]: {
                type: 'house_gardenPumpFrameWidget',
                properties: { id },
            },
            [Common.WidgetSize.FullScreen]: {
                type: 'house_gardenPumpScreenWidget',
                properties: { id },
            },
        },
    }),
};
export function houseComponentRegister(type) {
    switch (type) {
        case 'graphs':
            return GraphsRender;
        case 'dashboardroombutton':
            return RenderDashboardRoomButton;
        case 'dashboardroomfull':
            return RenderDashboardRoomFull;
        case 'hotwaterpumpbutton':
            return RenderHotWaterPumpButtonRender;
        case 'processbutton':
            return RenderProcessButton;
        case 'roombuttonwidget':
            return RenderRoomButtonWidget;
        case 'roomframewidget':
            return RenderRoomFrameWidget;
        case 'roomscreenwidget':
            return RenderRoomScreenWidget;
        case 'gardenpumpbuttonwidget':
            return RenderGardenPumpButtonWidget;
        case 'gardenpumpframewidget':
            return RenderGardenPumpFrameWidget;
        case 'gardenpumpscreenwidget':
            return RenderGardenPumpScreenWidget;
    }
}
export function useHouseWidgets() {
    const spa = Common.useSpaContext();
    const result = React.useMemo(() => {
        const controlWidgets = createControlWidgets(spa.state || {});
        const processWidgets = createProcessWidgets(spa.process || {});
        return [...controlWidgets, ...processWidgets];
    }, [spa.state, spa.process]);
    return result;
}
function isControlObject(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value);
}
function createControlWidgets(state) {
    return mapControlWidgets(state);
}
function mapControlWidgets(node, parentPath = '') {
    const widgets = [];
    for (const key of Object.keys(node)) {
        const current = node[key];
        if (!isControlObject(current)) {
            continue;
        }
        const currentPath = parentPath ? `${parentPath}.${key}` : key;
        const childWidgets = mapControlWidgets(current, currentPath);
        const currentWidget = createControlWidget(current, currentPath, key, parentPath);
        if (!currentWidget) {
            widgets.push(...childWidgets);
            continue;
        }
        if (childWidgets.length > 0) {
            currentWidget.children = childWidgets;
        }
        widgets.push(currentWidget);
    }
    return widgets;
}
function createControlWidget(controlObject, id, key, parentPath) {
    const type = controlObject?.type;
    if (typeof type !== 'string') {
        return undefined;
    }
    const normalizedType = type.toLowerCase();
    const hasFactory = Object.prototype.hasOwnProperty.call(controlWidgetFactories, normalizedType);
    const factory = hasFactory
        ? controlWidgetFactories[normalizedType]
        : undefined;
    const defaultFactory = ({ id, key }) => ({
        id,
        title: Mlt.getName(key),
        components: {
            [Common.WidgetSize.MinButton]: {
                type: 'widgetbutton',
                properties: { id },
            },
        },
        defaultPlacement: {
            type: Common.WidgetPlaceholderType.Tiles,
            size: Common.WidgetSize.Button,
            placeholderName: parentPath,
        },
    });
    const selectedFactory = factory || defaultFactory;
    return selectedFactory({ id, key });
}
function createProcessWidgets(processInfo) {
    if (!isControlObject(processInfo)) {
        return [];
    }
    const widgets = [];
    for (const process of Object.keys(processInfo)) {
        const processState = processInfo[process];
        if (!processState || processState === 'null') {
            continue;
        }
        const name = isControlObject(processState) && typeof processState.name === 'string'
            ? processState.name
            : 'Process';
        const widget = {
            id: 'process-' + process,
            title: {
                en: name,
                cs: name,
            },
            components: {
                [Common.WidgetSize.Frame]: {
                    type: 'Process',
                    properties: { id: process },
                },
            },
            defaultPlacement: {
                type: Common.WidgetPlaceholderType.Floating,
                size: Common.WidgetSize.Frame,
                isDefault: true,
                x: 'calc(100% - 800px - 2rem)',
                y: 'calc(100% - 300px - 1rem)',
                width: 400,
                height: 300,
            },
        };
        widgets.push(widget);
    }
    return widgets;
}
// export function Cmp(component: Common.IComponent, index?: number): React.ReactNode {
// }
